import { useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeFacebookJSSDK } from '../redux/actions';
import logger from '../logger';
import { isFacebookSDKInitialized } from '../redux/selectors';
import { loadScript } from '../utils';
var SCRIPT_ID = 'facebook-js-sdk';
var SCRIPT_SRC = 'https://connect.facebook.net/en_US/sdk.js';
export default function useFacebookSignIn(appId, onSuccess) {
    var sdkState = useRef('not-ready');
    var isInitialized = useSelector(isFacebookSDKInitialized);
    var dispatch = useDispatch();
    var doSignIn = useCallback(function () {
        FB.login(function (response) {
            logger.info('Facebook auth response ', response.authResponse);
            onSuccess(response);
        }, { scope: 'email' });
    }, [onSuccess]);
    useEffect(function () {
        if (typeof window !== 'undefined' &&
            !window.fbAsyncInit &&
            !isInitialized) {
            window.fbAsyncInit = function () {
                logger.info('fbAsyncInit called');
                FB.init({
                    appId: appId,
                    xfbml: false,
                    version: 'v14.0',
                });
                dispatch(initializeFacebookJSSDK());
                sdkState.current = 'ready';
                doSignIn();
            };
        }
    }, [isInitialized, appId, dispatch, doSignIn]);
    var signIn = function () {
        switch (sdkState.current) {
            case 'not-ready':
                sdkState.current = 'loading';
                loadScript(SCRIPT_ID, SCRIPT_SRC);
                break;
            case 'ready':
                doSignIn();
                break;
            case 'loading':
            default:
                break;
        }
    };
    return { signIn: signIn };
}
//# sourceMappingURL=useFacebookSignIn.js.map